import { ReactLocation, createBrowserHistory } from "@tanstack/react-location";

import type { LocationGenerics } from "./locationGenerics";

/**
 * Not barrel-exported: `createBrowserHistory()` runs on import, so it stays behind an explicit
 * path rather than firing for anything that reaches for a router helper.
 */
export const history = createBrowserHistory();

export const location = new ReactLocation<LocationGenerics>({ history });
